import React, { useState } from "react";

export default function SetPasswordView({ onSetPassword, onBack }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    onSetPassword(newPassword);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#000",
        color: "#fff",
        padding: "2rem",
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >
      <h2>Create a New Local Password</h2>
      <p style={{ maxWidth: "320px", color: "#aaa", fontSize: "0.95rem", marginTop: "0.5rem" }}>
        This password encrypts your contacts and settings on this device only.
        It does not sync or back up online. If you lose this password, your contacts must be re-added manually.
      </p>

      <input
        type="password"
        placeholder="Enter new password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        style={{
          padding: "0.5rem",
          fontSize: "1rem",
          marginTop: "2rem",
          borderRadius: "4px",
          border: "none",
          width: "220px",
          backgroundColor: "rgb(50 50 50)",
          color: "#fff",
        }}
      />
      <input
        type="password"
        placeholder="Confirm password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        style={{
          padding: "0.5rem",
          fontSize: "1rem",
          marginTop: "1rem",
          borderRadius: "4px",
          border: "none",
          width: "220px",
          backgroundColor: "rgb(50 50 50)",
          color: "#fff",
        }}
      />

      {error && <div style={{ color: "#f88", marginTop: "1rem" }}>{error}</div>}

      <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
        <button
          onClick={handleSubmit}
          style={{
            padding: "0.5rem 1rem",
            fontSize: "1rem",
            borderRadius: "4px",
            border: "none",
            backgroundColor: "#4e8cff",
            color: "white",
            cursor: "pointer",
          }}
        >
          Set Password
        </button>
        <button
          onClick={onBack}
          style={{
            padding: "0.5rem 1rem",
            fontSize: "1rem",
            borderRadius: "4px",
            border: "1px solid #4e8cff",
            backgroundColor: "transparent",
            color: "#4e8cff",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}